import apiSlice from "./ApiSlice";

const FollowupNoteApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // get all delivery dates
        getAllFollowupNoteData: builder.query({
            providesTags: ["followup-note"],
            query: (body: PaginationPayloadType) => {
                return {
                    url: "/followup-note",
                    method: "POST",
                    body,
                };
            },
        }),

        // delete delivery date
        deleteFollowupNoteById: builder.mutation({
            invalidatesTags: ["followup-note"],
            query: (id: any) => ({
                url: `/followup-note/${id}`,
                method: "DELETE",
            }),
        }),
        // add delivery date
        addFollowupNote: builder.mutation({
            invalidatesTags: ["followup-note"],
            query: (body) => ({
                url: `/followup-note/add`,
                method: "POST",
                body,
            }),
        }),
        //get delivery date by Id
        getFollowupNoteById: builder.query({
            providesTags: ["followup-note"],
            query: (id: string) => {
                return {
                    url: `/followup-note/${id}`,
                    method: "GET",
                };
            },
        }),

        // update delivery date
        updateFollowupNoteById: builder.mutation({
            invalidatesTags: ["followup-note"],
            query: ({ body, id }) => ({
                url: `/followup-note/${id}`,
                method: "PUT",
                body,
            }),
        }),

        // change status of delivery date
        changeStatusFollowupNoteById: builder.mutation({
            invalidatesTags: ["followup-note"],
            query: ({ body, id }) => ({
                url: `/followup-note/status-change/${id}`,
                method: "PUT",
                body,
            }),
        }),
       
    }),
});

export const {
    useGetAllFollowupNoteDataQuery,
    useDeleteFollowupNoteByIdMutation,
    useAddFollowupNoteMutation,
    useGetFollowupNoteByIdQuery,
    useUpdateFollowupNoteByIdMutation,
    useChangeStatusFollowupNoteByIdMutation,
} = FollowupNoteApi;
